// quiet-hours-schema.ts
//
// Split out of config-schema.ts (200-line budget) when H9 added real
// validation of the window.
import { z } from "zod";

// H9 (audit 2026-09-28): validated in the SCHEMA so a bad window is `config_invalid`
// at init/run, not an unhandled throw from quiet-hours-scheduler.ts on the
// first dispatch ("xx:yy" threw there; "25:99" even slipped through).
// D7 (backlog 2026-10-06): `.regex`, not `.refine` — the generator turns a
// regex into a JSON-schema `pattern`, so the published
// templates/autopilot/config.schema.json (byte-equal, schema-parity test)
// rejects the same windows the CLI does. `.refine` left the file blind.
const HH_MM = /^([01]\d|2[0-3]):[0-5]\d$/;

function isKnownTimeZone(zone: string): boolean {
  try {
    new Intl.DateTimeFormat("en-US", { timeZone: zone });
    return true;
  } catch {
    return false;
  }
}

export const QuietHoursSchema = z
  .object({
    start: z.string().min(1).regex(HH_MM, "quiet_hours.start phải dạng HH:MM (00:00–23:59)"),
    end: z.string().min(1).regex(HH_MM, "quiet_hours.end phải dạng HH:MM (00:00–23:59)"),
    timezone: z
      .string()
      .min(1)
      .refine(isKnownTimeZone, "quiet_hours.timezone không phải IANA zone"),
  })
  .strict();
